module.exports = __webpack_public_path__ + "img/simulacao.8daf1144.jpg";